module.exports = __webpack_public_path__ + "img/15.b44a6bcc.png";